import { TrendingForYouLook } from "../../../domain/projections/TrendingForYouLook";
import { TrendingForYouLookRepository } from "../../../domain/repositories/TrendingForYouLookRepository";
import { createHttpClients } from "../shared/createHttpClients";
import { mapTrendingForYouLookDTOtoTrendingForYouLook, TrendingForYouLookDTO } from "./responseMapper";

class TrendingForYouLookRepositoryImpl implements TrendingForYouLookRepository {
  private static instance: TrendingForYouLookRepositoryImpl;

  private constructor() {}

  public static getInstance(): TrendingForYouLookRepositoryImpl {
    if (!TrendingForYouLookRepositoryImpl.instance) {
      TrendingForYouLookRepositoryImpl.instance = new TrendingForYouLookRepositoryImpl();
    }

    return TrendingForYouLookRepositoryImpl.instance;
  }

  public async get(auth: string, apiUrl: () => string): Promise<TrendingForYouLook[]> {
    try {
      const { httpPost } = createHttpClients(auth, apiUrl);
      const { looks } = await httpPost<{ looks: TrendingForYouLookDTO[] }>({
        endpoint: `/trending/v1/view-recommendation`,
        body: {},
      });
      return looks.map((look: TrendingForYouLookDTO) => mapTrendingForYouLookDTOtoTrendingForYouLook(look));
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export { TrendingForYouLookRepositoryImpl };
